import { render } from "./galley-content-view.vue?vue&type=template&id=4aff95a8&scoped=true"
import script from "./galley-content-view.vue?vue&type=script&lang=js"
export * from "./galley-content-view.vue?vue&type=script&lang=js"

import "./galley-content-view.vue?vue&type=style&index=0&id=4aff95a8&scoped=true&lang=css"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aff95a8"]])

export default __exports__